import React, { useState } from 'react';
import { Icon } from '@fikasio/react-ui-components';
import { useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useAddItemMutation } from 'services/items/api';
import { Item } from 'services/items/types';
import { clearPaneContent } from 'services/pane/slice';
import ItemsList from './ItemsList';
import SelectionBar from 'components/UI/SelectionBar';
import AddItemButton from './AddItemButton';

const ItemsView = ({
  entity,
  items,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState('LIST');
  const [selectedItems, setSelectedItems] = useState<Item[]>([]);

  const [createItem] = useAddItemMutation();

  const addItem = async item => {
    return createItem({
      entityId: entity.id,
      ...item,
    })
      .then(({ data }) => {
        dispatch(clearPaneContent());
        return data;
      });
  };

  const handleSelectItem = item => {
    const isItemAlreadySelected = selectedItems.find(a => a.id === item.id);
    if (isItemAlreadySelected) {
      setSelectedItems([
        ...selectedItems.filter(a => a.id !== item.id),
      ]);
    } else {
      setSelectedItems([
        ...selectedItems,
        item,
      ]);
    }
  };

  let itemView;
  if (viewMode === 'LIST') {
    itemView = (
      <ItemsList
        entity={entity}
        items={items}
        onAddItem={item => addItem(item)}
        onItemSelect={handleSelectItem}
        onSelectAllItems={itemsArray => setSelectedItems(itemsArray)}
        selectedItems={selectedItems}
      />
    );
  } else {
    itemView = null;
  }

  return (
    <>
      <div>
        <AddItemButton
          entity={entity}
          style={{
            float: 'right',
            marginRight: 0,
          }}
        />
        <Button
          variant="outline-secondary"
          active={viewMode === 'LIST'}
          onClick={() => setViewMode('LIST')}
        >
          <Icon name="list" size="1x" />
        </Button>
        <Button
          onClick={() => setViewMode('BOARD')}
          active={viewMode === 'BOARD'}
          variant="outline-secondary"
        >
          <Icon name="th" size="1x" />
        </Button>
      </div>
      { itemView }
      {
        selectedItems.length > 0 && (
          <SelectionBar>
            <b>
              {t('xSelectedItems', { count: selectedItems.length })}
            </b>
          </SelectionBar>
        )
      }
    </>
  );
};

export default ItemsView;
